exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".DnLVKwwY7PXcq1duHNTnu{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;overflow:hidden;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);
// Exports
exports.locals = {
	"phoneNumberContainer": "DnLVKwwY7PXcq1duHNTnu"
};